'use client';
import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
export const SiteMapTitle = () => {
  const t = useTranslations();
  return (
    <div className="my-3">
      <CatHeading decorator level="h4">
        {t('FOOTER_SITE_MAP')}
      </CatHeading>
    </div>
  );
};
